import React from 'react';
import { FormattedMessage } from 'react-intl';
import { MaybeUndef } from '../../types/system';
import { NewIconNames } from '../common/icon/new-icon-names';
// import { FilesSelection } from '../common/upload-button/upload-button';
import { JsonEditor, JsonEditorProps } from '../json-editor/json-editor';
import { ComponentToolbarLayout } from '../layout/component-toolbar-layout/component-toolbar-layout';
import { ModalJsonEditable } from '../modals/modal-json-editable/modal-json-editable';
import { ActionButton } from './action-button/action-button';
// import { ImportActionButton } from './import-action-button/import-action-button';
import { Editor } from 'codemirror';

export interface JsonEditorWithToolbarProps extends JsonEditorProps {
  title?: React.ReactNode;
}

interface State {
  isModalOpened: boolean;
  jsonTextForModal: MaybeUndef<string>;
}

export class JsonEditorWithToolbar extends React.Component<
  JsonEditorWithToolbarProps,
  State
> {
  public state: State = {
    isModalOpened: false,
    jsonTextForModal: undefined,
  };
  private codeMirrorInstance: MaybeUndef<Editor>;

  private onCodeMirrorInstance(instance: Editor) {
    this.codeMirrorInstance = instance;
  }

  private submitTextFromModal(json: string) {
    if (this.codeMirrorInstance) {
      this.codeMirrorInstance.setValue(json);
    }
  }

  // private setTextFromFile(data: FilesSelection) {
  //   if (data.length === 0) {
  //     return;
  //   }
  //
  //   const reader = new window.FileReader();
  //
  //   reader.onload = () => {
  //     if (this.codeMirrorInstance) {
  //       this.codeMirrorInstance.setValue(reader.result as string);
  //     }
  //   };
  //
  //   reader.readAsText(data[0]);
  // }

  private showModal() {
    this.setState({
      isModalOpened: true,
      jsonTextForModal:
        this.codeMirrorInstance && this.codeMirrorInstance.getValue(),
    });
  }

  private hideModal() {
    this.setState({
      isModalOpened: false,
      jsonTextForModal: undefined,
    });
  }

  private submitModal(jsonText: string) {
    this.hideModal();
    this.submitTextFromModal(jsonText);
  }

  public render() {
    const { title, ...restProps } = this.props;
    const { jsonTextForModal, isModalOpened } = this.state;

    return (
      <ComponentToolbarLayout
        label={title}
        actions={[
          // <ImportActionButton
          //   key="import"
          //   onUpload={this.setTextFromFile.bind(this)}
          // />,
          <ActionButton
            key="external"
            dataHook="json-editor-toolbar-button-external"
            onClick={this.showModal.bind(this)}
            iconName={NewIconNames.ExternalLink}
            tooltip={
              <FormattedMessage id="components.json-editor-with-toolbar.actions.expand" />
            }
          />,
        ]}
      >
        <JsonEditor
          {...restProps}
          onInstanceReceive={this.onCodeMirrorInstance.bind(this)}
        />

        {isModalOpened ? (
          <ModalJsonEditable
            isOpen
            title={title}
            onClose={this.hideModal.bind(this)}
            onSubmit={this.submitModal.bind(this)}
            jsonString={jsonTextForModal}
            jsonSchema={restProps.jsonSchema}
          />
        ) : null}
      </ComponentToolbarLayout>
    );
  }
}
